export default __webpack_public_path__ + "static/media/Maria-Cayanan-grid.fa00b80d.jpg";